export default "__VITE_ASSET__DyI0HWXf__";